<template>
  <div class="inspection-abnormal-condition">
    <div class="abnormal-header">
      <div class="header-title">{{ $t('最近30天异常情况') }}</div>
    </div>
    
    <div class="abnormal-content">
      <div class="chart-section" style="height: 32%">
        <div class="chart-title">{{ $t('故障设备排名') }}</div>
        <div ref="chart1" class="chart-container"></div>
      </div>
      
      <div class="chart-section" style="height: 34%">
        <div class="chart-title">{{ $t('故障隐患趋势') }}</div>
        <div ref="chart2" class="chart-container"></div>
      </div>
      
      <div class="chart-section" style="height: 34%">
        <div class="chart-title">{{ $t('故障设备分布') }}</div>
        <div ref="chart3" class="chart-container"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { postAction } from '@/api/manage'
export default {
  name: 'InspectionAbnormalCondition',
  data() {
    return {
      url: {
        LargeScreenSumDeviceAnomalyRankingByTime: "/jeecg-engineering/inspection/inspectionTask/LargeScreenSumDeviceAnomalyRankingByTime",
        LargeScreenSumDeviceAnomalyTrendByTime: "/jeecg-engineering/inspection/inspectionTask/LargeScreenSumDeviceAnomalyTrendByTime",
        LargeScreenSumDeviceAnomalyTypeByTime: "/jeecg-engineering/inspection/inspectionTask/LargeScreenSumDeviceAnomalyTypeByTime"
      },
      charts: {
        chart1: null,
        chart2: null,
        chart3: null
      }
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.disposeCharts()
  },
  methods: {
    init() {
      this.getData1()
      this.getData2()
      this.getData3()
    },
    getData1() {
      postAction(this.url.LargeScreenSumDeviceAnomalyRankingByTime, {}).then(res => {
        if (res.success) {
          const data = res.result
          this.setOption1(data)
        }
      })
    },
    setOption1(data) {
      const y1 = data.map(item => item.num || 0)
      const y2 = data.map(item => item.deviceName || '')
      
      const option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0,11,42,0.9)',
          borderColor: '#5D6A94',
          borderWidth: 1,
          borderRadius: 8,
          textStyle: { color: '#CEE2FF' }
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '3%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { 
            color: '#8BA6C6',
            fontSize: 10
          },
          splitLine: {
            lineStyle: { color: 'rgba(0, 170, 255, 0.1)' }
          }
        },
        yAxis: {
          type: 'category',
          data: y2,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { 
            color: '#8BA6C6',
            fontSize: 10
          }
        },
        series: [{
          name: this.$t('异常数量'),
          type: 'bar',
          data: y1,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: '#00E4FF' },
              { offset: 1, color: '#00FF88' }
            ]),
            borderRadius: [0, 4, 4, 0]
          },
          barWidth: '60%',
          label: {
            show: true,
            position: 'right',
            color: '#fff',
            fontSize: 10
          }
        }]
      }
      
      this.renderChart('chart1', option)
    },
    getData2() {
      postAction(this.url.LargeScreenSumDeviceAnomalyTrendByTime, {}).then(res => {
        if (res.success) {
          const data = res.result
          this.setOption2(data)
        }
      })
    },
    setOption2(data) {
      const y1 = data.map(item => item.num || 0)
      const y2 = data.map(item => item.time || '')
      
      const option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0,11,42,0.9)',
          borderColor: '#5D6A94',
          borderWidth: 1,
          borderRadius: 8,
          textStyle: { color: '#CEE2FF' }
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '3%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: y2,
          boundaryGap: true,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { 
            color: '#8BA6C6',
            fontSize: 10
          }
        },
        yAxis: {
          type: 'value',
          name: this.$t('单位:个'),
          nameTextStyle: { color: '#8BA6C6', fontSize: 10 },
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { 
            color: '#8BA6C6',
            fontSize: 10
          },
          splitLine: {
            lineStyle: { color: 'rgba(0, 170, 255, 0.1)' }
          }
        },
        series: [{
          name: this.$t('异常趋势'),
          type: 'line',
          data: y1,
          smooth: true,
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            color: '#00E4FF'
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(0, 228, 255, 0.3)' },
              { offset: 1, color: 'rgba(0, 228, 255, 0.05)' }
            ])
          },
          lineStyle: {
            color: '#00E4FF',
            width: 2
          }
        }]
      }
      
      this.renderChart('chart2', option)
    },
    getData3() {
      postAction(this.url.LargeScreenSumDeviceAnomalyTypeByTime, {}).then(res => {
        if (res.success) {
          const data = res.result
          this.setOption3(data)
        }
      })
    },
    setOption3(data) {
      const seriesData = data.map(item => ({
        name: item.deviceName || '',
        value: item.num || 0
      }))
      const colors = ['#00E4FF', '#00FF88', '#FFB800', '#FF4D4F', '#722ED1', '#13C2C2']
      
      const option = {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0,11,42,0.9)',
          borderColor: '#5D6A94',
          borderWidth: 1,
          borderRadius: 8,
          textStyle: { color: '#CEE2FF' }
        },
        legend: {
          orient: 'vertical',
          right: '5%',
          top: 'center',
          textStyle: {
            color: '#8BA6C6',
            fontSize: 10
          },
          itemWidth: 10,
          itemHeight: 10
        },
        series: [{
          name: this.$t('故障分布'),
          type: 'pie',
          radius: ['30%', '70%'],
          center: ['40%', '50%'],
          data: seriesData,
          itemStyle: {
            borderRadius: 5,
            borderColor: 'rgba(255,255,255,0.1)',
            borderWidth: 1
          },
          label: {
            show: false
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 170, 255, 0.5)'
            }
          },
          color: colors
        }]
      }
      
      this.renderChart('chart3', option)
    },
    renderChart(chartName, option) {
      this.$nextTick(() => {
        const chart = echarts.init(this.$refs[chartName])
        chart.setOption(option)
        this.charts[chartName] = chart
        
        window.addEventListener('resize', () => {
          chart.resize()
        })
      })
    },
    disposeCharts() {
      Object.values(this.charts).forEach(chart => {
        if (chart) {
          chart.dispose()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.inspection-abnormal-condition {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: rgba(0, 48, 111, 0.2);
  border: 1px solid rgba(0, 170, 255, 0.2);
  border-radius: 8px;
  overflow: hidden;
}

.abnormal-header {
  padding: 5px 15px;
  border-bottom: 1px solid rgba(0, 170, 255, 0.2);
  background: linear-gradient(135deg, rgba(1, 32, 67, 0.8) 0%, rgba(0, 48, 111, 0.6) 100%);
}

.header-title {
  color: #b6deff;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
}

.abnormal-content {
  flex: 1;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.chart-section {
  background: rgba(0, 48, 111, 0.3);
  border: 1px solid rgba(0, 170, 255, 0.1);
  border-radius: 6px;
  padding: 12px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.chart-section:hover {
  border-color: rgba(0, 170, 255, 0.3);
  box-shadow: 0 2px 8px rgba(0, 170, 255, 0.1);
}

.chart-title {
  color: #00E4FF;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  text-align: left;
  text-shadow: 0 0 10px rgba(0, 228, 255, 0.5);
}

.chart-container {
  width: 100%;
  height: calc(100% - 25px);
}

@media (max-width: 1600px) {
  .abnormal-header {
    padding: 12px;
  }
  
  .header-title {
    font-size: 14px;
  }
  
  .abnormal-content {
    padding: 12px;
    gap: 12px;
  }
  
  .chart-section {
    padding: 10px;
  }
  
  .chart-title {
    font-size: 12px;
    margin-bottom: 6px;
  }
}

@media (max-width: 1200px) {
  .abnormal-header {
    padding: 10px;
  }
  
  .header-title {
    font-size: 13px;
  }
  
  .abnormal-content {
    padding: 10px;
    gap: 10px;
  }
  
  .chart-section {
    padding: 8px;
  }
  
  .chart-title {
    font-size: 11px;
  }
}
</style>